// Cara Ldn 9.0: tiny scroll-snap slider for the quote card and icon slider blocks. Added by Claude, reversible.
if (!customElements.get('cara-o-slider')) {
  customElements.define('cara-o-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = [...this.track.children];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go((this.index() + 1) % this.slides.length));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
      const ms = Number(this.dataset.autoplay || 0);
      if (ms && this.slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const tick = () => { if (!this.matches(':hover, :focus-within')) this.go((this.index() + 1) % this.slides.length); };
        this.timer = setInterval(tick, ms);
      }
    }
    disconnectedCallback() { clearInterval(this.timer); }
    index() { return Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth)); }
    go(i) { this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' }); }
    sync() {
      const n = this.index();
      this.dots.forEach((d, i) => d.setAttribute('aria-current', i === n ? 'true' : 'false'));
    }
  });
}
